/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PolicySeverityQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("PolicySeverityQueryOperator");
    }

    getFixupPrototypeFunction() { return PolicySeverityQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<PolicySeverityQueryOperator>): PolicySeverityQueryOperator {
        let obj = Object.assign(new PolicySeverityQueryOperator(), model);
        PolicySeverityQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PolicySeverityQueryOperator>): PolicySeverityQueryOperator {
        if (!model) return null;
        return PolicySeverityQueryOperator.newInstance(<PolicySeverityQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PolicySeverityQueryOperator) {
        if (!obj) return;

        models.PolicySeverityQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PolicySeverityQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, PolicySeverityQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Policy severities to include
     */
    severities: Array<models.PolicySeverity>;

}
